import React, {useCallback, useEffect, useMemo} from "react";
import {routes} from "../../../../core/models/static/routes/app-routes";
import {useTheme} from "@mui/material";
import {useHistory, useLocation} from "react-router-dom";
import {useConfigureNotebook} from "../../../hooks/use-notebook-config";
import {useAuthenticationState} from "../../../hooks/use-auth-state";

const ServerErrorView = ({root = false}) => {
    const theme = useTheme();
    const history = useHistory();
    const location = useLocation();
    const {toggleShow: toggleShowNotebooksAction} = useConfigureNotebook('auth-routes');
    const {loggedIn} = useAuthenticationState();
    const isRoot = useMemo(() => location.pathname === routes.error.serverError, [location.pathname]);

    /**
     * As soon as the component is mounted, it hides the notebooks feature
     */
    useEffect(() => {
        toggleShowNotebooksAction(false);
    }, [toggleShowNotebooksAction])

    /**
     * checks the pathname of the url based on serverErrorForSection route,
     * no prefix => change the url to serverErrorForSection
     * prefix of routes.auth.base => change the url to serverError
     *
     */
    useEffect(() => {
        if (location.pathname === routes.error.serverErrorForSection) {
            history.replace(routes.error.serverError);
        }
        if (location.pathname.includes(routes.auth.base)) {
            history.replace(routes.error.serverError);
        }
    }, [history, location.pathname])

    /**
     * retries the page that caused the error
     * @type {() => void}
     */
    const retry = useCallback(() => {
        history.goBack();
    }, [history]);

    /**
     * goes back to the previous page form the erroneous page
     * @type {() => void}
     */
    const goBack = useCallback(() => {
        if (history.length > 2) {
            history.go(-2);
        } else {
            window.close();
        }
    }, [history]);

    return (
        <div
            className={`error-page ${root ? "root" : ''} row no-gutters flex-column flex-md-row justify-content-around justify-content-md-around align-items-center`}>
            <svg width="380px" height="500px" viewBox="0 0 837 1045" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                        d="M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z"
                        id="Polygon-1" stroke={theme.palette.primary.main} strokeWidth="6"/>
                    <path
                        d="M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z"
                        id="Polygon-2" stroke={theme.palette.tertiary.main} strokeWidth="6"/>
                    <path
                        d="M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z"
                        id="Polygon-3" stroke={theme.palette.secondary.main} strokeWidth="6"/>
                    <path
                        d="M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z"
                        id="Polygon-4" stroke={theme.palette.tertiary.main} strokeWidth="6"/>
                    <path
                        d="M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z"
                        id="Polygon-5" stroke={theme.palette.secondary.main} strokeWidth="6"/>
                </g>
            </svg>
            <div className="message-box">
                <h1>
                    500
                </h1>
                <p>
                    Server Error. Sorry, there seems to be a problem with our servers. Please Contact IT. Meanwhile, feel
                    free to try again momentarily.
                </p>
                <div className="action-link-wrap">
                    <button onClick={retry} className='animated-button btn'>
                        <span>Sorry again</span><span>Retry</span>
                    </button>
                    <button onClick={goBack} className='animated-button btn'>
                        <span>Sorry again</span><span>Go Back</span>
                    </button>
                    {
                        loggedIn && isRoot &&
                        <button onClick={() => history.replace(routes.landing)} className='animated-button btn'>
                            <span>Sorry again</span><span>Go to Home</span>
                        </button>
                    }
                </div>
            </div>
        </div>
    );
}

export default ServerErrorView;
